<div
  class="proforma-status-page min-h-screen flex justify-center items-start px-4 sm:px-6 lg:px-8 py-6 sm:py-8 md:py-10 pb-28 md:pb-10 bg-[#FAFAFA]"
>
  <div class="w-full max-w-[644px] flex flex-col items-center gap-4 sm:gap-6 md:gap-8">
    <!-- Status icon + title -->
    <div
      class="w-full max-w-[470px] flex flex-col items-center gap-2"
      [@slideInFromTop]="confirmationVisible ? 'visible' : 'void'"
    >
      <!-- Success Icon -->
      <div
        class="w-16 h-16 sm:w-20 sm:h-20 relative flex items-center justify-center"
        *ngIf="success"
      >
        <svg
          class="w-12 h-12 sm:w-[52px] sm:h-[52px]"
          viewBox="0 0 52 52"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <circle cx="26" cy="26" r="26" fill="#16A34A" />
          <path
            d="M15 27.5L22.5 35L37 18.5"
            stroke="white"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <!-- Failed Icon -->
      <div
        class="w-16 h-16 sm:w-20 sm:h-20 relative flex items-center justify-center"
        *ngIf="!success"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          fill="#DC2626"
          class="w-12 h-12 sm:w-14 sm:h-14"
          aria-hidden="true"
        >
          <g>
            <path
              d="M22.36,11.05,21,9.64a2,2,0,0,0-2.83,0L16,11.76,13.88,9.64a2,2,0,0,0-2.83,0L9.64,11.05a2,2,0,0,0,0,2.83L11.76,16,9.64,18.12a2,2,0,0,0,0,2.83l1.41,1.41a2,2,0,0,0,2.83,0L16,20.24l2.12,2.12a2,2,0,0,0,2.83,0L22.36,21a2,2,0,0,0,0-2.83L20.24,16l2.12-2.12A2,2,0,0,0,22.36,11.05Zm-4.24,4.24a1,1,0,0,0,0,1.42L21,19.54,19.54,21l-2.83-2.83a1,1,0,0,0-1.42,0L12.46,21l-1.41-1.41,2.83-2.83a1,1,0,0,0,0-1.42l-2.83-2.83,1.41-1.41,2.83,2.83a1,1,0,0,0,1.42,0l2.83-2.83L21,12.46Z"
            />
            <path
              d="M16,1A15,15,0,1,0,31,16,15,15,0,0,0,16,1Zm0,28A13,13,0,1,1,29,16,13,13,0,0,1,16,29Z"
            />
          </g>
        </svg>
      </div>

      <!-- Main Headline -->
      <h1
        *ngIf="success"
        class="w-full text-center text-green-600 text-2xl sm:text-3xl font-bold leading-tight"
      >
        Payment Successful
      </h1>
      <h1
        *ngIf="!success"
        class="w-full text-center text-red-600 text-2xl sm:text-3xl font-bold leading-tight"
      >
        Payment Failed
      </h1>

      <!-- Status Subtext -->
      <p
        *ngIf="success"
        class="w-full text-center text-gray-700 text-sm sm:text-base font-medium leading-normal"
      >
        Your proforma invoice payment has been processed successfully. Your order is being processed.
      </p>
      <p
        *ngIf="!success"
        class="w-full text-center text-gray-700 text-sm sm:text-base font-medium leading-normal"
      >
        Your proforma payment could not be completed. Any deducted amount will be refunded within 2–4 business days.
      </p>

      <!-- Proforma Reference Pill -->
      <div
        *ngIf="bookingNumber || invoiceId || orderNumber"
        class="mt-1 px-4 py-1.5 rounded-full bg-blue-50 border border-blue-200 text-[#0A0A5F] text-xs sm:text-sm font-semibold"
      >
        Proforma Invoice: {{ bookingNumber || invoiceId || orderNumber }}
      </div>
    </div>

    <!-- Payment Notice Banner -->
    <div
      *ngIf="success"
      class="w-full p-3.5 sm:p-4 rounded-xl border border-green-200 bg-green-50 flex items-center justify-between"
      [@fadeIn]="confirmationVisible ? 'visible' : 'void'"
    >
      <div class="flex items-center gap-2 sm:gap-3">
        <div class="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center shrink-0">
          <svg class="w-4 h-4 text-green-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <div>
          <div class="text-green-900 text-sm sm:text-base font-bold">
            Amount Paid: {{ formatPrice(paymentAmount) }}
          </div>
          <div class="text-green-700 text-xs sm:text-sm font-medium">
            Paid via CCAvenue Gateway
          </div>
        </div>
      </div>
      <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-semibold bg-green-200 text-green-800">
        Paid
      </span>
    </div>

    <div
      *ngIf="!success"
      class="w-full p-3.5 sm:p-4 rounded-xl border border-red-200 bg-red-50 flex items-center justify-between"
      [@fadeIn]="confirmationVisible ? 'visible' : 'void'"
    >
      <div class="flex items-center gap-2 sm:gap-3">
        <div class="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center shrink-0">
          <svg class="w-4 h-4 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <div>
          <div class="text-red-900 text-sm sm:text-base font-bold">
            Payment Unsuccessful: {{ formatPrice(paymentAmount) }}
          </div>
          <div class="text-red-700 text-xs sm:text-sm font-medium">
            Transaction was not completed. Please retry.
          </div>
        </div>
      </div>
      <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-semibold bg-red-200 text-red-800">
        Failed
      </span>
    </div>

    <!-- Proforma Summary Card -->
    <div
      class="w-full bg-white rounded-xl border border-gray-200 p-4 sm:p-6 flex flex-col gap-4 shadow-sm"
      [@slideInFromBottom]="detailsVisible ? 'visible' : 'void'"
    >
      <div class="flex items-center justify-between border-b border-gray-100 pb-3">
        <h2 class="text-black text-base sm:text-lg font-bold">
          Proforma Summary - # {{ bookingNumber || orderNumber || orderId }}
        </h2>
        <span
          class="text-xs sm:text-sm font-semibold px-2.5 py-0.5 rounded-full"
          [ngClass]="success ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'"
        >
          {{ success ? 'Payment Confirmed' : 'Payment Pending' }}
        </span>
      </div>

      <!-- Item List -->
      <div class="flex flex-col gap-3 sm:gap-4 divide-y divide-gray-100" *ngIf="items?.length">
        <div
          class="order-item-card pt-3 first:pt-0 flex gap-3 sm:gap-4 items-start"
          *ngFor="let item of items"
        >
          <div
            class="relative w-20 h-16 sm:w-24 sm:h-20 rounded-lg overflow-hidden bg-gray-50 border border-gray-200 shrink-0 flex items-center justify-center"
          >
            <img
              class="w-full h-full object-cover"
              [src]="item?.part_image || item?.image_url || 'assets/default.webp'"
              [alt]="item?.part_name || item?.part_desc || 'Part'"
            />
          </div>

          <div class="flex-1 min-w-0 flex flex-col gap-1">
            <h3 class="text-sm sm:text-base font-bold text-black leading-snug line-clamp-2">
              {{ item?.part_name || item?.part_desc || 'Spare Part' }}
            </h3>

            <div class="flex flex-wrap items-center gap-1.5 text-xs text-gray-500 font-medium">
              <span *ngIf="item?.category">{{ item?.category }}</span>
              <span *ngIf="item?.category && item?.sub_category" class="text-gray-300">•</span>
              <span *ngIf="item?.sub_category">{{ item?.sub_category }}</span>
            </div>

            <div
              class="flex items-center justify-between mt-1 text-xs sm:text-sm font-medium"
              *ngIf="item?.quantity || item?.booking_amount || item?.price"
            >
              <span class="text-gray-600" *ngIf="item?.quantity">
                Qty: <strong class="text-black">{{ item?.quantity }}</strong>
              </span>
              <span class="font-bold text-black" *ngIf="item?.booking_amount || item?.price">
                {{ formatPrice(item?.booking_amount || item?.price) }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Delivery / Store Address Section (if available) -->
      <div
        class="border-t border-gray-100 pt-3 flex flex-col gap-1 text-xs sm:text-sm"
        *ngIf="deliveryAddress"
      >
        <span class="text-gray-500 font-medium">Delivery Address:</span>
        <p class="text-black font-semibold leading-relaxed">
          {{ deliveryAddress?.address_1 || deliveryAddress?.street_address || '' }}
          {{ deliveryAddress?.city ? ', ' + deliveryAddress.city : '' }}
          {{ deliveryAddress?.state ? ', ' + deliveryAddress.state : '' }}
          {{ deliveryAddress?.pincode ? ' - ' + deliveryAddress.pincode : '' }}
        </p>
      </div>

      <!-- Total Price Breakdown -->
      <div class="border-t border-gray-100 pt-3 flex flex-col gap-2">
        <div class="flex justify-between items-center text-xs sm:text-sm text-gray-600">
          <span>Payment Gateway</span>
          <span class="font-medium text-black">CCAvenue</span>
        </div>
        <div class="flex justify-between items-center text-sm sm:text-base font-bold text-black">
          <span>Total Proforma Amount</span>
          <span class="text-primary-deep-blue text-base sm:text-lg">
            {{ formatPrice(paymentAmount) }}
          </span>
        </div>
      </div>
    </div>

    <!-- Desktop / Tablet Action Buttons -->
    <div
      class="hidden md:flex w-full gap-3 lg:gap-4"
      [@fadeIn]="buttonsVisible ? 'visible' : 'void'"
    >
      <button
        type="button"
        class="flex-1 h-12 rounded-lg border border-[#0A0A5F] text-[#0A0A5F] text-base font-bold hover:bg-blue-50 transition-colors"
        (click)="gotoShopping()"
      >
        Continue Shopping
      </button>

      <!-- If payment succeeded: View Order Details -->
      <button
        *ngIf="success"
        type="button"
        class="flex-1 h-12 rounded-lg bg-[#0A0A5F] text-white text-base font-bold hover:bg-[#08084d] transition-colors shadow-sm"
        (click)="gotoOrderDetails()"
      >
        View Order Details
      </button>

      <!-- If payment failed: Retry Payment -->
      <button
        *ngIf="!success"
        type="button"
        class="flex-1 h-12 rounded-lg bg-[#0A0A5F] text-white text-base font-bold hover:bg-[#08084d] transition-colors shadow-sm"
        (click)="retryPayment()"
      >
        Retry Payment
      </button>
    </div>
  </div>

  <!-- Mobile Sticky CTAs -->
  <div
    class="cta-bar-mobile md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 sm:p-4 z-[41]"
  >
    <div class="flex gap-2 sm:gap-3 max-w-[644px] mx-auto">
      <button
        type="button"
        class="flex-1 h-11 sm:h-12 rounded-lg border border-[#0A0A5F] text-[#0A0A5F] text-sm sm:text-base font-bold"
        (click)="gotoShopping()"
      >
        Continue Shopping
      </button>

      <button
        *ngIf="success"
        type="button"
        class="flex-1 h-11 sm:h-12 rounded-lg bg-[#0A0A5F] text-white text-sm sm:text-base font-bold shadow-sm"
        (click)="gotoOrderDetails()"
      >
        View Order Details
      </button>

      <button
        *ngIf="!success"
        type="button"
        class="flex-1 h-11 sm:h-12 rounded-lg bg-[#0A0A5F] text-white text-sm sm:text-base font-bold shadow-sm"
        (click)="retryPayment()"
      >
        Retry Payment
      </button>
    </div>
  </div>
</div>
